import styled from 'styled-components';

export const Wrapper = styled.div`
  color: ${({ theme }) => theme.inputs.textarea.colors.placeholder};
  font-size: ${({ theme }) => theme.basic.fontSizes.small};
`;
